import React from 'react';

import classNames from 'classnames';
import { faPenToSquare, faVolume, faVolumeSlash } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';

import { useConversationContext } from '../conversation_context';

interface Props {
  logoPath: string;
}

// The phone view is a whole page rather than a panel, so it wears the app's own header instead of the
// sidebar's card title.
export function MobileHeader({ logoPath }: Props) {
  const {
    busy, isAdmin, messages, speaking, startNewChat, toggleAdminDetails, toggleVoice, ttsSupported, voiceEnabled,
  } = useConversationContext();

  return (
    <Card.Header className="ai-assistant-mobile-header d-flex align-items-center">
      <img
        alt="Buildout"
        className="ai-assistant-mobile-logo me-auto"
        src={logoPath}
        onClick={isAdmin ? toggleAdminDetails : undefined}
      />
      {ttsSupported && (
        <Button
          aria-label={voiceEnabled ? 'Mute voice replies' : 'Unmute voice replies'}
          className={classNames({ 'text-warning': speaking && voiceEnabled })}
          icon={voiceEnabled ? faVolume : faVolumeSlash}
          variant="ghost"
          onClick={toggleVoice}
        />
      )}
      <Button
        aria-label="New chat"
        disabled={busy || messages.length === 0}
        icon={faPenToSquare}
        tooltip="New chat"
        variant="ghost"
        onClick={startNewChat}
      />
    </Card.Header>
  );
}
